import React, { memo } from "react";
import StatsRow from "./StatsRow";

const defaultStatsRows = [
  {
    label: "Total",
    statKey: ["totalParcels", "totalStops"],
  },
  {
    label: "By 10:30",
    statKey: "totalBy1030",
  },
  {
    label: "By 12",
    statKey: "totalBy12",
  },
  {
    label: "Perishable",
    statKey: "totalPerishable",
  },
  {
    label: "Precise",
    statKey: "totalPrecise",
  },
  {
    label: "Weekend",
    statKey: "totalWeekend",
  },
];

const StatsInfoRows = ({
  route,
  statsRowsConfig,
  labelStyle,
  withCollection = true,
}) => {
  const statsRows = statsRowsConfig || defaultStatsRows;

  return (
    <>
      {statsRows.map(({ label, statKey }, index) => (
        <StatsRow
          key={statKey}
          label={label}
          route={route}
          statKey={statKey}
          labelClassName={labelStyle}
          totalCollectionStops={
            index === 0 && withCollection ? route?.totalCollectionStops : null
          }
        />
      ))}
    </>
  );
};

export default memo(StatsInfoRows);
